import React, { useCallback, useState, Suspense } from 'react';
import Popover from '@mui/material/Popover';
import { Button } from 'react-bootstrap';
import { ControlText } from '@victorequena22/component-bootstrap';
import { UseIcon } from '../UseIcon';
import Cargando from '../Cargando';
import IconCatalog from './IconCatalog';
export function IconSelector(_a) {
    var value = _a.value, onChange = _a.onChange, className = _a.className, disabled = _a.disabled, nullValue = _a.nullValue, _b = _a.style, style = _b === void 0 ? { width: 36, height: 24 } : _b;
    var _c = useState(''), search = _c[0], setSearch = _c[1];
    var _d = useState(null), open = _d[0], setOpen = _d[1];
    var handleClick = useCallback(function (event) { return setOpen(event.currentTarget); }, []);
    var handleClose = useCallback(function () { return setOpen(null); }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { "data-tip": 'SELECCIONAR ICONO', disabled: disabled, variant: 'outline-dark', style: style, size: 'sm', className: className, onClick: handleClick },
            React.createElement(UseIcon, { width: '15', height: '15', fill: '#000000', icon: value })),
        React.createElement(Popover, { open: open, anchorEl: open, onClose: handleClose, anchorOrigin: { vertical: 'bottom', horizontal: 'left' } },
            React.createElement(ControlText, { before: 'BUSCAR', after: React.createElement("i", { className: 'fa fa-search' }), setData: setSearch, value: search }),
            React.createElement(Suspense, { fallback: React.createElement(Cargando, null) },
                React.createElement(IconCatalog, { nullValue: nullValue, search: search, close: handleClose, onChange: onChange })))));
}
//# sourceMappingURL=index.js.map